export default __webpack_public_path__ + "static/media/trackbot-graphic.9c086628.png";